import { useMemo } from "react";
import { HgProduct } from "../../../../../types/taxonomy";
import useGetAllProducts from "../../../../../hooks/useGetAllProducts";
import { ProductRow } from "../types";

const getJoinedAttributesNames = (attributes: HgProduct["attributes"]) => {
  const attributesName =
    attributes?.map(({ name }) => {
      return name;
    }) || [];

  return attributesName.join(", ");
};

export const useGetProductRows = (
  filteredProducts?: HgProduct[]
): {
  isLoading: boolean;
  productRows: ProductRow[];
} => {
  let { loading, products } = useGetAllProducts();

  if (filteredProducts) {
    loading = false;
    products = filteredProducts;
  }

  const productRows = useMemo<ProductRow[]>(() => {
    return products.map((product) => {
      const attributes = getJoinedAttributesNames(product.attributes);

      return {
        id: product.id.toString(),
        product: product.name,
        category: product.category?.name ?? "",
        vendor: product.vendor?.name ?? "",
        vendorId: product.vendor?.id ?? null,
        attributes,
      };
    });
  }, [products]);

  return {
    isLoading: loading,
    productRows,
  };
};
